<template>
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="24" height="24" rx="12" fill="#F2F7FD" />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M7.52834 14.4127L14.4123 7.52868C14.6723 7.26868 15.0943 7.26868 15.3543 7.52868L16.4717 8.64601C16.7317 8.90601 16.7317 9.32801 16.4717 9.58801L9.58701 16.4713C9.46234 16.5967 9.29301 16.6667 9.11634 16.6667H7.33301V14.8833C7.33301 14.7067 7.40301 14.5373 7.52834 14.4127Z"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M13.167 8.77335L15.227 10.8333"
      stroke="currentColor"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>
